export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Runs `fn` and guarantees the returned promise settles no sooner than `minMs`.
// Useful for keeping loading UIs visible long enough to feel intentional, even
// when the underlying work resolves instantly (cached responses, validation errors).
export const withMinDuration = async (fn, minMs) => {
    const startedAt = Date.now();
    try {
        return await fn();
    } finally {
        const elapsed = Date.now() - startedAt;
        if (elapsed < minMs) {
            await sleep(minMs - elapsed);
        }
    }
};
